import React from 'react'
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { Link } from 'react-router-dom';
import { Avatar } from '@material-ui/core';

function InputGroupDropdown() {
    const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

    return (
        <>
            {/* <li><Link to="/connect" className="connectWithWallet">Connect <AccountBalanceWalletIcon /></Link></li> */}
            <Button className="connectWithWallet AccountCircle" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
              <div className="headerProfileIcon">
                <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg"/>
              </div>
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
            <MenuItem onClick={handleClose}><Link to="/create" className="connectWithWallet">Create Collectible</Link></MenuItem>
            <MenuItem onClick={handleClose}><Link to="/user/username" className="connectWithWallet">My Collectible</Link></MenuItem>
              <MenuItem onClick={handleClose}><Link to="/user/username/edit" className="connectWithWallet">Edit Profile</Link></MenuItem>
              <MenuItem onClick={handleClose}><Link to="#" className="connectWithWallet">Logout</Link></MenuItem>
            </Menu>
        </>
    )
}

export default InputGroupDropdown
